function pickRunway(runwayA, runwayB, wind, historicWind) {
  let runwayResult = useRunway(wind, runwayA);

  if(runwayResult === -1) {
    return useRunway(historicWind, runwayA) ? runwayA : runwayB;
  }

  return runwayResult ? runwayA : runwayB;
}

/**
 * Indicates if a given runway should be used given the current wind direction
 *
 * @param wind
 * @param runway - In this current iteration, runway should be one that is greater than 79 degrees, less than 269.
 *    We can refactor to handle cases like 350 degrees but this simplifies things somewhat
 * @returns true|false|-1: If -1 is returned, indicates that the direction is right on the boundary for using
 *    this runway. Used to determine if we should run the historic wind data.
 */
function useRunway(wind, runway) {
  //Multiply by 10 because the runway is usually displayed as 35 when it's 350, 17 when 170
  const min = runway * 10 - 90;
  const max = runway * 10 + 90;

  return (wind === min || wind === max) ? -1 : (min <= wind && max >= wind);
}

export default pickRunway;


/** WEBPACK FOOTER **
 ** ./src/Runway/pickRunway.js
 **/